import { allDefaultSessionsColumns, sessionsTableColumnsById, tableLightColors, allDefaultPerformerColumns, performerTableColumnsById, allDefaultSponsorSessionsColumns, sponsorSessionColumnsById, allDefaultSponsorsColumns, sponsorColumnsById, allDefaultAttendeesColumns, attendeeColumnsById } from './../../helpers/table-helpers';
import { createSelector } from '@ngrx/store';
import { performerStatus, performerStatusNames, getPublicEditProfileInfo, PublicEditProfileInfo, performersStateSelector } from '../performers.era';
import { getSet, setDifference, sortByProp, makeMapFromListOfObjectsAndKey, getList, convertObjectMapToList, getNestedSet, getNestedList, flatten } from 'globals/helpers/helpers';
import { eventStateSelector, LabelObject, WFWorker } from '../events.era';
import { columnOrderTypes, defaultColumns, settingsStateSelector } from '../settings.era';
import { nonSpecificPerformerName, Performer } from 'globals/store/performers.data';
import { ItemStatus, SessionItemInfo, BriefInfo, shareUrlsByType } from 'globals/store/share.data';
import { getBriefStatusBySessionAndPerformerId } from 'src/app/share/onsite.reselector.functions';
import { TableColumn, TableLights } from 'src/app/helpers/table.data';
import { SessionTableData, PerformerTableData, PerformerBriefTableData, PerformerBaseTableData, sessionColumns } from 'src/app/helpers/table-column-types';
import { getBriefLights, getStatusLights, getAssetLights, getBooleanLight, getActiveLights, SessionInfo, PerformerSessionInfoLite, sortByDateAndStart, ProgramsPerformersSponsors, SessionPerformerData, PerformerSessionInfo, NestedProgramInfo, fullSessionsEntitiesReselector, sessionsEntitiesReselector, filteredPerformersProgramsReselector, SessionsEntitiesData, SearchableSessionFields, getBooleanConfirmedLight } from './performerSponsors.reselector';
import { JoiEvent, Ranking } from 'globals/store/events.data';
// import { getPerformerBriefActions, getValidSortedStagingRequests } from '../share.brief.functions';
import { Dictionary } from '@ngrx/entity';
import { EntityRequest, Program, Session, SessionContentStatus } from 'globals/store/programs.data';
import { programsArray } from './programs.reselector';
import { UserSettings } from 'globals/store/user.data';
import { environment } from 'src/environments/environment';
import { JoiAccount } from 'globals/store/accounts.data';
import { getBasePerformerTableData, getReadyAssetLights } from './entity.decircular.reselector';
import { getMediaTermsLights } from "./entity.reselector.helpers";
import { EntitySubTable, performerSubTableTypes, sessionSubTableTypes, subTableIds } from 'globals/store/entity.data';
import { Asset } from 'globals/store/assets.data';
import { allAssociatedAssetsIdsReselector } from './entity.reselector';
import { sessionMapReselector } from './sessions.reselector';
import { BriefActions } from 'globals/store/brief.data';
import { getPerformerBriefActions, getValidSortedStagingRequests } from 'globals/store/share.brief.functions';
import { workforceStateSelector } from '../workforce.era';
import { shareStateSelector } from '../share.era';
import { programsStateSelector } from '../programs.era';
import { filterStateSelector } from '../filters.era';
import { accountStateSelector } from '../accounts.era';
import { assetsStateSelector } from '../assets.era';


const SearchablePerformerFields = ['name', 'phone', 'line1', 'line2', 'bio', 'email']

const workersByEmail = createSelector(workforceStateSelector, (state) => state.workersByEmail)
const performerLabels = createSelector(eventStateSelector, (state) => state.labelMaps.performer_labels)
const profileShareables = createSelector(shareStateSelector, (state) => state.profile)
const sessionLabels = createSelector(eventStateSelector, (state) => state.labelMaps.session_labels)
const programLabels = createSelector(eventStateSelector, (state) => state.labelMaps.program_labels)
const performerEntities = createSelector(performersStateSelector, (state) => state.entities)
const performerIds = createSelector(performersStateSelector, (state) => state.ids)
const userSettings = createSelector(settingsStateSelector, (state) => state.user)
const presentationAssets = createSelector(shareStateSelector, (state) => state.asset)
const performerBriefs = createSelector(shareStateSelector, (state) => state.performer)
const programs = createSelector(programsStateSelector, (state) => state.entities)
const performerBriefSearchTerm = createSelector(filterStateSelector, (state) => state.performerBrief.search)
const performerTableFilters = createSelector(filterStateSelector, (state) => state.performersTable)
const sessionTableFilters = createSelector(filterStateSelector, (state) => state.performerSessionsTable)
const event = createSelector(eventStateSelector, (state) => state.event)
const account = createSelector(accountStateSelector, (state) => state.account)
const accounts = createSelector(accountStateSelector, (state) => state.entities)
const synopsisShareables = createSelector(shareStateSelector, (state) => state.synopsis)
const stagingShareables = createSelector(shareStateSelector, (state) => state.stagingRequest)
const entityAssetShareables = createSelector(shareStateSelector, (state) => state.entityAsset)
const performerTypes = createSelector(performersStateSelector, (state) => state.performerTypes)
const assets = createSelector(assetsStateSelector, (state) => state.entities)


 const getSessionContentStatusLights = (status: SessionContentStatus): TableLights => {
  const color: {[k in SessionContentStatus]: string} = {
    'Not Confirmed': tableLightColors.gray,
    'Confirmed': tableLightColors.green,
    'In Progress': tableLightColors.yellow,
    'Review': tableLightColors.red
  };
  return {lights:[{ color: color[status], text: status as string }]}
}

export const performerBriefActionsReselector = createSelector(
  profileShareables,
  synopsisShareables,
  stagingShareables,
  presentationAssets,
  event,
  programsArray,
  entityAssetShareables,
  getPerformerBriefActions
)

export const allPerformerBriefActionsReselector = createSelector(
  profileShareables,
  synopsisShareables,
  stagingShareables,
  presentationAssets,
  event,
  programsArray,
  entityAssetShareables,
  performerIds,
   (profiles: { [id: string]: PublicEditProfileInfo }, synopses: { [id:string]: SessionItemInfo }, stagings: { [id:string]: SessionItemInfo }, assets: { [id:string]: SessionItemInfo }, event: JoiEvent, programs: Program[], entityAssetShareables, performerIds: string[]) => {
      const briefActionsMap: { [pId: string]: BriefActions} = {}
      performerIds.forEach(pId => briefActionsMap[pId] = getPerformerBriefActions(profiles, synopses, stagings, assets, event, programs, entityAssetShareables, pId))
      return briefActionsMap
   }
  
)

export const stagingRequestsReselector = createSelector(
  performerEntities,
  programs,
  (performers: Dictionary<Performer>, programs: Dictionary<Program>, { sessionId, programId }) => {
    console.log({ sessionId, programId, programs })
    return getValidSortedStagingRequests(programs[programId].sessions_obj[sessionId]?.stagingRequests || [], performers) 
  }
)

export const stagingRequestsBySessionIdReselector = createSelector(
  performerEntities,
  programs,
  (performers: Dictionary<Performer>, programs: Dictionary<Program>) => {
    const stagingRequestsBySessionId: Dictionary<EntityRequest[]> = {}
    Object.values(programs).forEach(program => Object.values(program.sessions_obj).forEach(session => stagingRequestsBySessionId[session.id] = getValidSortedStagingRequests(session.stagingRequests || [], performers)))
    return stagingRequestsBySessionId
  }
)


export const performerSessionBriefStatusReselector = createSelector(
  performerEntities,
  programs,
  getBriefStatusBySessionAndPerformerId
)

// Note:  The reselectors that are based off of the resulting filtered programsList and performerList below are used in many different places throughout the app.  Hence the store value that determines the appropriate filters to apply (often no filters)

export const performerColumnsReselector = createSelector(
  userSettings,
  event,
  (settings: UserSettings, event): { [t in EntitySubTable]: TableColumn[] } => {

    const tableColumnsMap: { [t in EntitySubTable]: TableColumn[] } = {} as { [t in EntitySubTable]: TableColumn[] }
    if (!event) return tableColumnsMap
    subTableIds.forEach(id => {
      if (id === 'responses') return
      const selectedColumns = !settings ? null : settings[`${performerSubTableTypes[id]}_columns`]
      const defaults = defaultColumns[performerSubTableTypes[id]]
      const columns = selectedColumns || defaults
      if (columns) tableColumnsMap[id] = columns.filter(c => c.selected).map(c => performerTableColumnsById[c.value]).filter((c: TableColumn) => !c.notOuter)
    })
    return tableColumnsMap
  }
)

export const sponsorColumnsReselector = createSelector(
  userSettings,
  (settings) => {
    const selectedColumns = !settings ? null : settings[`${columnOrderTypes.sponsors}_columns`]
    // console.log({ selectedColumns, settings })
    return (!selectedColumns ? allDefaultSponsorsColumns : selectedColumns.filter(c => c.selected).map(c => sponsorColumnsById[c.value])).filter((c: TableColumn) => !c.notOuter)
  }
)


export const attendeeColumnsReselector = createSelector(
  userSettings,
  (settings) => {
    const selectedColumns = !settings ? null : settings[`${columnOrderTypes.attendees}_columns`]
    // console.log({ selectedColumns, settings })
    return (!selectedColumns ? allDefaultAttendeesColumns : selectedColumns.filter(c => c.selected).map(c => attendeeColumnsById[c.value])).filter((c: TableColumn) => !c.notOuter)
  }
)

export const sponsorSessionColumnsReselector = createSelector(
  userSettings,
  (settings) => {
    const selectedColumns = !settings ? null : settings[`${columnOrderTypes.sponsor_sessions}_columns`]
    // console.log({ selectedColumns, settings })
    return (!selectedColumns ? allDefaultSponsorSessionsColumns : selectedColumns.filter(c => c.selected).map(c => sponsorSessionColumnsById[c.value])).filter((c: TableColumn) => !c.notOuter)
  }
)

export const sessionsColumnsReselector = createSelector(
  userSettings,
  (settings) => {
    const tableColumnsMap: { [t in EntitySubTable]: TableColumn[] } = {} as { [t in EntitySubTable]: TableColumn[] }
    const subTableIds: EntitySubTable[] = ['publish', 'myView', 'logistics']
    subTableIds.forEach(id => {
      const selectedColumns = !settings ? null : settings[`${sessionSubTableTypes[id]}_columns`]
      const defaults = defaultColumns[sessionSubTableTypes[id]]
      const columns = selectedColumns || defaults
      if (columns) tableColumnsMap[id] = columns.filter(c => c.selected).map(c => sessionsTableColumnsById[c.value]).filter((c: TableColumn) => !c.notOuter)
    })
    return tableColumnsMap
  }
)

export const extractSingleSessionPerformersData = (sessionInfo: SessionInfo, filteredPerformersList: Performer[], performers: { [id: string]: Performer }, synopsis: SessionItemInfo): SessionInfo => {

  const usedPerformerIds = getSet(sessionInfo.performerInfos, 'performerId')
  const unusedPerformerIds: Set<string> = !performers ? new Set() : setDifference<string>(new Set(filteredPerformersList.map(p => p.id)), usedPerformerIds)
  const synopsisPerformer = synopsis && synopsis.performerId && usedPerformerIds.has(synopsis.performerId) ? performers[synopsis.performerId] : null
  const anyoneOption = { id: null, title: nonSpecificPerformerName }
  const performerList = !performers ? [] : sessionInfo.performerIds.map(id => performers[id]).filter(p => p && usedPerformerIds.has(p.id))

  const singleSessionInfo: SessionInfo = {
    ...sessionInfo,
    performers: performerList,
    unusedPerformers: !performers ? [] : Array.from(unusedPerformerIds).map(id => performers[id]).filter(p => p).sort(sortByProp('name')),
    dropdownSelection: !synopsisPerformer ? anyoneOption : { id: synopsisPerformer.id, title: synopsisPerformer.name + ' (Performer)' },
    dropdownSelections: [ anyoneOption, ...performerList.map(p=>({ id:p.id, title: p.name + ' (Performer)' })) ]
  }
  // console.log({ singleSessionInfo, sessionInfo, performerList })
  return singleSessionInfo
}


export const singleSessionPerformersReselector = createSelector( // for manage session and the performers component
  fullSessionsEntitiesReselector,
  performerEntities,
  synopsisShareables,
  ({ sessionInfos }: SessionsEntitiesData, performers: { [id: string]: Performer }, synopses: { [id:string]: SessionItemInfo }, sessionId: string) => sessionInfos && sessionId && sessionInfos[sessionId] ? extractSingleSessionPerformersData(sessionInfos[sessionId], Object.values(performers), performers, synopses[sessionId]) : null
)

export const sessionPerformerReselector = createSelector( // for manage performer
  fullSessionsEntitiesReselector,
  ({ sessionInfos, performerSessionInfosByPerformerId, unusedSessionIdsByPerformerId }: SessionsEntitiesData, performerId: string): SessionPerformerData => {

    const pSessionInfos = performerSessionInfosByPerformerId[performerId]
    if (!pSessionInfos) return { sessionList: [], sessionProgramList: [] }

    const sessionList: PerformerSessionInfo[] = pSessionInfos.map(({ sessionId, status, briefStatus }) => ({ ...sessionInfos[sessionId], status, briefStatus }))

    sessionList.sort(sortByDateAndStart)
    const unusedSessionIds = unusedSessionIdsByPerformerId[performerId]
    unusedSessionIds.sort((a, b) => sortByDateAndStart(sessionInfos[a], sessionInfos[b]))

    const sessionProgramList: NestedProgramInfo[] = []

    let programListIndex = 0
    const programIdToListLocation = {}
    unusedSessionIds.forEach(id => {
      const session = sessionInfos[id]
      const { programId, programTitle } = session
      if (!programIdToListLocation.hasOwnProperty(programId)) {
        programIdToListLocation[programId] = programListIndex++
        sessionProgramList.push({ programId, programTitle, sessionList: [] })
      }
      sessionProgramList[programIdToListLocation[programId]].sessionList.push({ ...session, selected: false })
    })

    return { sessionList, sessionProgramList }
  }
)

export const performerContactReselector = createSelector(
  workersByEmail,
  performerEntities,
  (workersByEmail, performers, performerId: string) => {
    if (!workersByEmail || !performers) return { contact: null, performer: null }
    const performer = performers[performerId]
    if (!performer) return { contact: null, performer: null }
    return { performer, contact: workersByEmail[performer.contact] } // contact can be undefined
  }
)

const getSessionTableData = (sessionInfo: SessionInfo, sessionLabels: LabelObject, programLabels: LabelObject, stagingRequestInfos: {[code:string]: SessionItemInfo}, synopsis: SessionItemInfo, assetsMap: Dictionary<Asset>, sessions: Dictionary<Session>, associatedAssetIdsByEntityId: Dictionary<string[]>, event: JoiEvent): SessionTableData => {
  const { id, title: name, contentStatus, date, flag, start, end, duration, performerInfos, sessionLabels: sLabels, programLabels: pLabels, description, programTitle: programName, day, sponsorInfos } = sessionInfo
  const HHMMText = `${start} - ${end}` + (!date ? '' : ', ')
  const nestedIds = getList(performerInfos, 'performerId')
  const summary = getStatusLights(performerInfos, 'performers')
  const briefed = getBriefLights(performerInfos)
  

  const session = sessions[sessionInfo.id]
  const { performerIds, sponsorIds,  } = session  

  const performerAssetIds = flatten((performerIds || []).map(performerId => associatedAssetIdsByEntityId[performerId]).filter(a => a?.length))
  const sponsorAssetIds = flatten((sponsorIds || []).map(sponsorId => associatedAssetIdsByEntityId[sponsorId]).filter(a => a?.length))

  const stagingStatus = [stagingRequestInfos[`${sessionInfo.id}_`], ...performerInfos.map(({ performerId }) => stagingRequestInfos[`${sessionInfo.id}_${performerId}`])].map((stagingRequest: SessionItemInfo): ItemStatus => !stagingRequest ? 'Off' : stagingRequest.status)

  const stagingRequests = getAssetLights(stagingStatus)
  // if (stagingRequests?.lights?.length > 1) console.log({ id: sessionInfo.id, stagingStatus, stagingRequests, stagingRequestInfos })

  const synopsisStatus = !synopsis ? 'Off' : synopsis.status

  const performerSessionData: SessionTableData = {
    duration: { text: `${sessionInfo.duration || 0} minutes`},
    performerAssets: getReadyAssetLights(performerAssetIds, assetsMap),
    sponsorAssets: getReadyAssetLights(sponsorAssetIds, assetsMap),
    id,
    nestedIds,
    sessionInfo,
    stagingRequests,
    attendees: { text: ((session.attendeeTags || []).filter(t => event.attendees[t]).length + '') },
    sessionUrl: {
      percent: synopsisStatus === 'Off' ? -1 : synopsis.status === 'Active' ? 0 : 1,
      lights: [{
        text: synopsisStatus,
        color: synopsisStatus === 'Submitted' ? tableLightColors.green : synopsisStatus === 'Active' ? tableLightColors.yellow : tableLightColors.gray
      }]
    },
    noNestedText: 'This sesssion does not have any performers assigned',
    performerStatus: Object.assign({}, ...performerInfos.map(({ performerId, status }) => ({
      [performerId]:
    {
      percent: status === performerStatus.Accepted ? 1 : status === performerStatus.Pending ? 0.5 : status === performerStatus.Declined ? 0 : -1,
      lights: [{
        text: performerStatusNames[status],
        color: status === performerStatus.Accepted ? tableLightColors.green : status === performerStatus.Pending ? tableLightColors.yellow : status === performerStatus.Declined ? tableLightColors.red : tableLightColors.gray
      }]
    }
    }))),
    name: { text: name },
    confirmed: getSessionContentStatusLights(contentStatus) ,
    dateTime: { HHMMText, date, day, extraDateData: [start, duration + "", end] },
    performers: { text: performerInfos.length.toString() },
    programName: { text: programName },
    description: { text: description },
    flagged: { flagged: flag },
    sessionLabels: !sLabels ? [] : sLabels.filter(l => sessionLabels[l]).map(label => ({ color: sessionLabels[label].color, label: sessionLabels[label].label })),
    programLabels: !pLabels ? [] : pLabels.filter(l => programLabels[l]).map(label => ({ color: programLabels[label].color, label: programLabels[label].label })),
    summary,
    sponsors: { text: sponsorInfos.length + ''},
    stagingNotes: { text: session.notes || '' },
    publicLinks: { text: (session.publicLinks?.length || 0) + '' },
    briefNotes: { text: (session.presentationNotes?.length || 0) + '' },
    briefed,
    assets: getReadyAssetLights(session.assetIds, assetsMap),
    showInPublish: getBooleanLight(!session.hideInPublish),
  }
  return performerSessionData
}

export const sessionTablePreselector = createSelector(
  programLabels,
  sessionLabels,
  assets,
  sessionMapReselector,
  allAssociatedAssetsIdsReselector,
  (programLabels, sessionLabels, assets, sessions, associatedAssetsIdByEntityId) => ({ programLabels, sessionLabels, assets, sessions, associatedAssetsIdByEntityId })
)

export const sessionTableReselector = createSelector(
  sessionTablePreselector,
  sessionsEntitiesReselector,
  sessionTableFilters,
  synopsisShareables,
  stagingShareables,
  event,
  ({ programLabels, sessionLabels, assets, sessions, associatedAssetsIdByEntityId }, 
    { sessionInfos }, sessionTableFilters, synopses: { [id:string]: SessionItemInfo }, stagings: { [id:string]: SessionItemInfo }, event) => {
    let sessionInfoList = sessionInfos ? Object.values(sessionInfos) : []

    const { search } = sessionTableFilters
    // console.log({ search, sessionInfoList })
    if (search) {
      const searchTerm = search.toLocaleLowerCase()
      sessionInfoList = sessionInfoList.filter(s => SearchableSessionFields.some(field => s[field] && s[field].toLocaleLowerCase().includes(searchTerm)))
    }
    // further filtering for sessions with no performers and performer filters active
    const performerFiltersActive = sessionTableFilters.performerLabels || sessionTableFilters.tags || sessionTableFilters.sponsorLabels
    if (performerFiltersActive) {
      sessionInfoList = sessionInfoList.filter(s => s.performerInfos.length || s.sponsorInfos.length)
    }

    // console.log({ sessionInfoList })

    const sessionTableData: SessionTableData[] = sessionInfoList.map(sessionInfo => getSessionTableData(sessionInfo, sessionLabels, programLabels, stagings, synopses[sessionInfo.id], assets, sessions, associatedAssetsIdByEntityId, event))
    const sessionTableRowsById = makeMapFromListOfObjectsAndKey(sessionTableData, 'id')
    return { sessionTableData, sessionTableRowsById }
  }
)

const getPerformerTableData = (performer: Performer, shareable: PublicEditProfileInfo, workersByEmail: { [key: string]: WFWorker }, performerLabels: LabelObject, performerSessionInfosByPerformerId: { [id: string]: PerformerSessionInfoLite[] }, briefInfo: BriefInfo, event: JoiEvent, briefActions: BriefActions, performerTypes: { [id: string]: Ranking }, associatedAssetIdByEntityId: Dictionary<string[]>, assets: Dictionary<Asset>, sessions: Dictionary<Session>): PerformerTableData => {
  const { id, contact: WFContactEmail, confirmed, labels, hideInPublish, entityTypeId, stars } = performer
  const contact = workersByEmail[WFContactEmail]
  const sessionInfos = performerSessionInfosByPerformerId[id] || []
  // console.log({ sessions, performerSessionInfosByPerformerId, id })
  const sessionIds = getList(sessionInfos, 'sessionId')
  const status = getStatusLights(sessionInfos, 'sessions')

  const sessionAssetIds = Array.from(new Set(getNestedList(sessionIds.map(id => sessions[id]), 'assetIds').filter(id => !!assets[id])))

  const briefOn = briefInfo && briefInfo.status === 'On'
  const hasActions = briefOn && !!briefActions?.total

  const performerType = !entityTypeId || !performerTypes[entityTypeId] ? null : performerTypes[entityTypeId]

  const performerData: PerformerTableData = {
    ...getBasePerformerTableData(performer),
    briefed: getBriefLights(sessionInfos, 'session'),
    contact: !contact ? null : contact,
    confirmed: getBooleanConfirmedLight(confirmed),
    labels: labels ? labels.filter(label => performerLabels[label]).map(label => ({ color: performerLabels[label].color, label: performerLabels[label].label })) : [],
    sessions: { text: `${ sessionInfos ? sessionInfos.length : 0 }` },
    status,
    publicEditProfileStatus: getActiveLights(shareable.status, shareable ? environment.joi.shareBase + shareUrlsByType.profile + '/' + shareable.code : null),
    nestedIds: sessionIds,
    assets: getReadyAssetLights(associatedAssetIdByEntityId[id], assets),
    sessionAssets: getReadyAssetLights(sessionAssetIds, assets),
    terms: !event ? null : getMediaTermsLights(event.mediaTerms.performer, performer, briefInfo),
    briefUrl: { url: briefOn ? environment.joi.shareBase + shareUrlsByType.performer + '/' + briefInfo.id : null, percent: briefOn ? 1 : 0, lights: [{ text: briefOn ? 'On' : 'Off', color: briefOn ? tableLightColors.green : tableLightColors.gray }]},
    briefActions: !hasActions ? null : { percent: briefActions.submitted / briefActions.total, lights: [{ text: `${briefActions.submitted} / ${briefActions.total} completed`, color: briefActions.total === briefActions.submitted ? tableLightColors.green : tableLightColors.red }] },
    hideInPublish: getBooleanLight(!hideInPublish),
    performerType: { rank: !performerType ? 0 : performerType.rank, text: !performerType ? '' : performerType.name }
  }
  return performerData
}

export const performerClipboardTableReselector = createSelector(
  account,
  accounts,
  (account: JoiAccount, accounts: Dictionary<JoiAccount>, accountId: string) => {
    const clipboardPerformers = Object.values(!accountId ? account.clipboard.performers : accounts[accountId]?.clipboard?.performers || {})
    const performerClipboardTableData: PerformerBaseTableData[] = clipboardPerformers.map(getBasePerformerTableData)
    const performerClipboardTableRowsById = makeMapFromListOfObjectsAndKey(performerClipboardTableData, 'id')
    return { performerClipboardTableData, performerClipboardTableRowsById }
  }
)

export const performerTablePreselector = createSelector( // a selector can only have 10 inputs at most
  workersByEmail,
  event,
  profileShareables,
  performerTypes,
  assets,
  allAssociatedAssetsIdsReselector,
  sessionMapReselector,
  (workersByEmail, event, profileShareables, performerTypes, assets, associatedAssetIdsByEntityId, sessions ) => 
    ({ event, workersByEmail, profileShareables, performerTypes, assets, associatedAssetIdsByEntityId, sessions })
)

export const performerTableReselector = createSelector(
  performerTablePreselector,
  filteredPerformersProgramsReselector,
  performerLabels,
  sessionsEntitiesReselector,
  performerTableFilters,
  performerBriefs,
  allPerformerBriefActionsReselector,
  ({ event, workersByEmail, profileShareables, performerTypes, assets, associatedAssetIdsByEntityId, sessions }, { performerList }: ProgramsPerformersSponsors, performerLabels, { performerSessionInfosByPerformerId }, performerTableFilters, performerBriefs, briefActionsMap: { [pId: string]: BriefActions }) => { // !!ALREADY HAS 9 inputs, must put additional into preselector or refactor more
    const { search, types } = performerTableFilters

    if (search) {
      const searchTerm = search.toLocaleLowerCase()
      performerList = performerList.filter(p => SearchablePerformerFields.some(field => p[field] && typeof p[field] === 'string' && p[field].toLocaleLowerCase().includes(searchTerm)))
    }
    if (types) performerList = performerList.filter(p => types.includes(p.entityTypeId))

    
    const sessionFiltersActive = performerTableFilters.sessionLabels || performerTableFilters.programLabels || performerTableFilters.programs
    if (sessionFiltersActive) {
      performerList = performerList.filter(p => performerSessionInfosByPerformerId[p.id].length)
    }

    const performerTableData: PerformerTableData[] = performerList.map(p => getPerformerTableData(p, getPublicEditProfileInfo('profile', p.id, profileShareables), workersByEmail, performerLabels, performerSessionInfosByPerformerId, performerBriefs[p.id], event, briefActionsMap[p.id], performerTypes, associatedAssetIdsByEntityId, assets, sessions ))
    const performerTableRowsById = makeMapFromListOfObjectsAndKey(performerTableData, 'id')
    return { performerTableData, performerTableRowsById }
  }
)

export const performerBriefsReselector = createSelector(
  performerEntities,
  fullSessionsEntitiesReselector,
  performerBriefs,
  performerBriefSearchTerm,
  event,
  (performerEntities, { performerSessionInfosByPerformerId }, performerBriefs, searchTerm: string, event: JoiEvent) => {
    searchTerm = searchTerm ? searchTerm.toLocaleUpperCase() : null
    const briefTableData: PerformerBriefTableData[] = Object.values(performerEntities)
      .filter(({ name }) => !searchTerm || name.toLocaleUpperCase().includes(searchTerm))
      .map((performer: Performer) => {
        let { id, name } = performer
        const performerSessionInfos = performerSessionInfosByPerformerId[id]
        if (!performerSessionInfos) {
          throw new Error("Missing performer session info")
        }
        const briefStatus = getBriefLights(performerSessionInfos, 'session')
        const brief = performerBriefs[id]
        const briefTableRow: PerformerBriefTableData = {
          id,
          name: { text: name },
          sessions: { text: performerSessionInfos.length.toString() },
          briefStatus,
          briefUrl: {
            percent:!brief || brief.status === 'Off' ? -1 : 1,
            lights: [{
              text: brief ? brief.status : 'Off',
              color: !brief || brief.status === 'Off' ? tableLightColors.gray : tableLightColors.green,
            }]},
          terms: !event ? null : getMediaTermsLights(event.mediaTerms.performer, performer, brief),
          assetInfo: [],
          performer
        }
        return briefTableRow
      })
    const briefTableRowsById = makeMapFromListOfObjectsAndKey(briefTableData, 'id')
    return { briefTableData, briefTableRowsById }
  }
)

